import React, { useEffect, useState, useRef } from 'react'
import { Modal, message, Upload } from 'antd'
import { Button } from '@shopify/polaris'
import { uploadFilesTracking } from '../../../services/api/TrackingMappingServices'
import { UploadOutlined } from "@ant-design/icons";


const ExportTrackingUpload = (props) => {

    const { refreshExportTracking } = props
    const [visible, setVisible] = useState(false)
    const [uploading, setUploading] = useState(false);
    const [errors, setErrors] = useState({})
    const [fileList, setFileList] = useState([]);
    const [uploadProgress, setUploadProgress] = useState({}); // { uid: percent }
    const skipBatchRef = useRef(false); // Flag chặn batch

    const showModal = () => {
        setVisible(true)
    }

    const handleBeforeUpload = (file, batch) => {
        // Nếu là file đầu tiên của batch mới
        if (file.uid === batch[0].uid) {
            const totalSize = [...fileList, ...batch].reduce(
                (sum, f) => sum + f.size,
                0
            );

            if (totalSize > 5 * 1024 * 1024) {
                message.error("The total size of the files exceeds 5MB!");
                skipBatchRef.current = true; // Chặn batch này
                return Upload.LIST_IGNORE;
            } else {
                skipBatchRef.current = false; // Reset
            }
        }

        // Nếu batch đang bị chặn → bỏ qua file này
        if (skipBatchRef.current) {
        return Upload.LIST_IGNORE;
        }

        // Chỉ cho phép CSV
        if (file.type !== "text/csv" && !file.name.endsWith(".csv")) {
        message.error(`${file.name} not a CSV file!`);
        return Upload.LIST_IGNORE;
        }

        return true;
    };

    const customUpload = ({ file, onProgress, onSuccess, onError }) => {
        // Giả lập upload
        let percent = 0;
        const interval = setInterval(() => {
        percent += 10;
        setUploadProgress((prev) => ({ ...prev, [file.uid]: percent }));
        onProgress({ percent });

        if (percent >= 100) {
            clearInterval(interval);
            onSuccess("ok");
        }
        }, 200);
    };

    const _handleCancel = () => {
        setVisible(false)
        setFileList([])
    }

    const _handleUpload = async () => {

        if (fileList.length === 0) {
            message.warning("Please select at least one CSV file!");
            return;
        }

        const formData = new FormData();
        fileList.forEach((file) => {
            formData.append("file", file.originFileObj);
        });

        setUploading(true);
        try {
            const {message: mess, success} = await uploadFilesTracking(formData)

            if (!success) return message.error(`${mess}!`)

            message.success("Upload successful!");
            _handleCancel()
            refreshExportTracking()
        } catch (error) {
            message.error("Upload error!");
            console.error(error);
        } finally {
            setUploading(false);
        }
        
    }

    return (
        <React.Fragment>
            <div className="mb-3">
                <Button primary onClick={showModal} icon={<UploadOutlined style={{fontSize: '20px'}}/>}>
                    Upload
                </Button>
            </div>
            <Modal
                title="Upload CSV"
                visible={visible}
                // onOk={_handleUpload}
                onCancel={_handleCancel}
                // okText="Upload"
                // cancelText="Cancel"
                footer={[
                    <Button onClick={_handleCancel}>
                        Cancel
                    </Button>,
                    <div style={{ marginLeft: 5, display: 'inline-block' }}>
                        <Button
                            primary
                            loading={uploading}
                            onClick={_handleUpload}
                            style={{ marginLeft: '5px' }}
                        >
                            {uploading ? "Uploading..." : "Upload"}
                        </Button>
                    </div>,
                ]}
                >
                    <Upload
                        multiple
                        fileList={fileList}
                        beforeUpload={handleBeforeUpload}
                        customRequest={customUpload}
                        onChange={({ fileList }) => setFileList(fileList)}
                    >
                        <Button icon={<UploadOutlined style={{fontSize: '20px'}}/>}>Select CSV file</Button>
                    </Upload>
                    <div className='mt-2'>
                        <small> File template input
                            <a href='https://docs.google.com/spreadsheets/d/1LCDv--gabkAIO-I4MgZAestoprk4KVbDo5MAhq-Am5U/edit?gid=0#gid=0' className='text-purple-700 font-bold' target="_blank"> here</a>
                        </small>
                    </div>
                </Modal>
        </React.Fragment>
    )
}

ExportTrackingUpload.propTypes = {
    // handleClickAdd: PropTypes.func.isRequired,
}

export default ExportTrackingUpload